import { render, staticRenderFns } from "./pagePois.vue?vue&type=template&id=4fe0b153&scoped=true&"
import script from "./pagePois.vue?vue&type=script&lang=js&"
export * from "./pagePois.vue?vue&type=script&lang=js&"
import style0 from "./pagePois.vue?vue&type=style&index=0&id=4fe0b153&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe0b153",
  null
  
)

export default component.exports